import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import { DataObject } from '@mui/icons-material';
import ReactInterval from 'react-interval';
import { BarChart } from '@mui/x-charts';

export interface IIpsByProvinciaChartState {
    totals: number[];
    labels: string[];
}

export default class IpsByProvinciaChart extends React.Component<{}, IIpsByProvinciaChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            totals: [],
            labels: []
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <ReactInterval timeout={5000} enabled={false} callback={() => {
                        this.Get();
                    }}/>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            IPs por provincia
                        </Typography>
                    </Box>
                    <BarChart
                        height={1000}
                        margin={{
                            left: 100
                        }}
                        series={[
                            { 
                                data: this.state.totals                                
                            }
                        ]}
                        yAxis={[{ data: this.state.labels, scaleType: 'band' }]}
                        colors={['#EF9912']}
                        layout="horizontal"
                        slotProps={{
                            legend: {
                                hidden: true
                                }
                            }}
                    />
                </CardContent>
            </Card>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/masters/ip/total/byprovincia`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const totals: number[] = [];
            const labels: string[] = [];
            
            for(let i = 0; i < response.length; i++) {
                totals.push(response[i].total);
                labels.push(response[i].provincia);
            }

            this.setState(
                {
                    totals: totals,
                    labels: labels
                }
            );
        })
    }
}